import React, { useState, useEffect } from 'react';
import '../css/components/ManageProfile.css';
import Loading from '../general/Loading';

const indianStates = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Jammu and Kashmir', 'Ladakh'
];

const ManageProfile = ({ userData, setResponse }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_name: '',
    shop_name: '',
    mobile: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    gst_no: '',
    pass: '',
    dealer_type: '',
  });

  const [isEditing, setIsEditing] = useState(false);

  // Pre-fill form with userData
  useEffect(() => {
    if (userData) {
      setFormData({
        user_name: userData.user_name || '',
        shop_name: userData.shop_name || '',
        mobile: userData.mobile || '',
        email: userData.email || '',
        address: userData.address || '',
        city: userData.city || '',
        state: userData.state || '',
        pincode: userData.pincode || '',
        gst_no: userData.gst_no || '',
        pass: userData.pass || '',
        dealer_type: userData.dealer_type || 'Admin',
      });
    }
  }, [userData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditProfile = async () => {
    const mobilePattern = /^[0-9]{10}$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const pincodePattern = /^[1-9][0-9]{5}$/;

    if (formData.mobile && !mobilePattern.test(formData.mobile)) {
      setResponse({ message: 'Enter valid 10-digit mobile number.', status: 'error' });
      setTimeout(() => setResponse(''), 3000);
      return;
    }

    if (formData.email && !emailPattern.test(formData.email)) {
      setResponse({ message: 'Enter valid email address.', status: 'error' });
      setTimeout(() => setResponse(''), 3000);
      return;
    }

setLoading(true);
    try {
      const response = await fetch(`https://api.siddhabhairabistore.com/update-profile/${userData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setLoading(false);
                    localStorage.setItem('userData', JSON.stringify(result));
        setResponse({ message: 'Profile updated successfully.', status: 'success' });
        setIsEditing(false);
            setTimeout(() => {setResponse('');
        window.location.reload();
            }, 2000);
      } else {
        setLoading(false);
        setResponse({ message: 'Something Went Wrong. Try Again Later', status: 'error' });
    setTimeout(() => setResponse(''), 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
    <section className='my-4'>
      <div className='px-4'>
        <p className='page-title'>Manage Profile</p>

        <div className='row g-3 mt-1'>
          {[
            { label: 'Your Name', name: 'user_name' },
            { label: 'Shop Name', name: 'shop_name' },
            { label: 'Mobile', name: 'mobile', type: 'tel' },
            { label: 'Email', name: 'email', type: 'email' },
            // { label: 'GST No', name: 'gst_no' },
            // { label: 'Password', name: 'pass' },
            { label: 'Address', name: 'address' },
            // { label: 'City', name: 'city' },
            // { label: 'Pincode', name: 'pincode', type: 'number' },
          ].map(({ label, name, type = 'text' }) => (
            <div key={name}>
                <div className='profile-input px-0'>
              <label className='profile-label'>{label}</label>
              <input
                type={type}
                className='profile-control'
                name={name}
                value={formData[name]}
                onChange={handleInputChange}
                disabled={!isEditing}
              />
              </div>
            </div>
          ))}

  <div className='col-lg-6'>
    <div className='profile-input px-0'>
      <label className='profile-label'>GST No</label>
      <input
        type='text'
        className='profile-control'
        name='gst_no'
        value={formData.gst_no}
        onChange={handleInputChange}
        disabled={!isEditing}
      />
    </div>
  </div>

  <div className='col-lg-6'>
    <div className='profile-input px-0'>
      <label className='profile-label'>Password</label>
      <input
        type='text'
        className='profile-control'
        name='pass'
        value={formData.pass}
        onChange={handleInputChange}
        disabled={!isEditing}
      />
    </div>
  </div>


  <div className='col-lg-6'>
    <div className='profile-input px-0'>
      <label className='profile-label'>City</label>
      <input
        type='text'
        className='profile-control'
        name='city'
        value={formData.city}
        onChange={handleInputChange}
        disabled={!isEditing}
      />
    </div>
  </div>

          <div className='col-lg-6'>
          <div className='profile-input px-0'>
            <label className='profile-label'>State</label>
            <select
              name='state'
              className='profile-control'
              value={formData.state}
              onChange={handleInputChange}
              disabled={!isEditing}
            >
              <option value="">Select State</option>
              {indianStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
          </div>

            <div>
    <div className='profile-input px-0'>
      <label className='profile-label'>Pincode</label>
      <input
        type='number'
        className='profile-control'
        name='pincode'
        value={formData.pincode}
        onChange={handleInputChange}
        disabled={!isEditing}
      />
    </div>
</div>


        </div>

        <div className='mt-4'>
          {isEditing ? (
            <>
              <button className='edit-btn me-2' onClick={handleEditProfile}>
                Save Changes
              </button>
              <button className='close-btn' onClick={() => setIsEditing(false)}>
                Cancel
              </button>
            </>
          ) : (
            <button className='edit-btn' onClick={() => setIsEditing(true)}>
              Edit Profile
            </button>
          )}
        </div>
      </div>
    </section>

    {loading && <Loading setLoading={setLoading} />}

</>
);
};

export default ManageProfile;
